import React, {useEffect, useRef} from 'react';
import axios from 'axios';


const infoChangeNotification = (props) => {

  const user_id = props.user_id;
  const error_message = useRef(null);

  const handleClick = () => {
    document.getElementById('alert').style.display='none';

    axios.defaults.headers.common['X-CSRF-TOKEN'] = document.querySelector('[name=csrf-token]').content;

    const param = { info_changed: false }
    axios.put('/admin/users/' + user_id + '/update_info_change', param).then((res) => { error_message.current.value = res.data });
  };

  return (
    <div>
      <div className="alert" id='alert'>
        <span className="closebtn" onClick={handleClick}>&times;</span>
        <p>The User has updated their general info</p>
      </div>
      {
        error_message === true &&
        <div className="alert">
          <span className="closebtn">&times;</span>
          <p>Some errors with update info change</p>
        </div>
      }
    </div>
  );
};

export default infoChangeNotification;
